import { render } from "./SetSex.vue?vue&type=template&id=856d8a98&scoped=true"
import script from "./SetSex.vue?vue&type=script&lang=js"
export * from "./SetSex.vue?vue&type=script&lang=js"

import "./SetSex.vue?vue&type=style&index=0&id=856d8a98&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-856d8a98"]])

export default __exports__